import { Page } from "components/Page";
import DashboardAppPage from "./Dashboard";
export const DashboardPage = () => {
  return (
    <Page title="Dashboard">
      <DashboardAppPage />
    </Page>
  );
};
